import { formValidationOptions } from 'modules/billing/TemporaryFund/configs/temporaryFundConfigs';
import { showFormErrorMessage } from 'modules/billing/TemporaryFund/helpers/temporaryFundHelpers';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { Controller } from 'react-hook-form';

const WITHDRAW_PAYMENT_TO_OPTIONS = [
  { label: 'To Available Trust Funds', value: 'transfer_in_trust_account' },
  { label: 'To Client', value: 'to_client' },
  { label: 'To Third Party', value: 'to_third_party' },
];

const TemporaryFundPaymentMethodV2 = (props) => {
  const { control, errors, isWithdraw } = props;

  const paymentMethodOptions = isWithdraw
    ? WITHDRAW_PAYMENT_TO_OPTIONS
    : [
        { label: 'Transfer from Trust Account', value: 'transfer_from_trust_account' },
        { label: 'Check Payment', value: 'cheque_payment' },
        { label: 'Credit Card', value: 'credit_card' },
      ];

  const paymentMethodRules = isWithdraw ? { required: 'Payment or Transfer is Required' } : formValidationOptions?.paymentMethod?.rules;
  const dropdownPlaceholder = isWithdraw ? 'Select Payment or Transfer' : 'Select Payment Method';

  return (
    <div className="d-flex align-items-top py-2 flex-wrap">
      <div className="col-12 col-sm-4 pt-2">
        {isWithdraw ? (
          <>
            Payment or Transfer<span className="alert-star">*</span>
          </>
        ) : (
          <>
            Payment Method<span className="alert-star">*</span>
          </>
        )}
      </div>
      <div className="col-12 col-sm-8 pt-2">
        <Controller
          control={control}
          name={formValidationOptions?.paymentMethod?.name}
          rules={paymentMethodRules}
          render={({ field }) => (
            <Dropdown
              className="input-shadow w-100 p-0"
              placeholder={dropdownPlaceholder}
              options={paymentMethodOptions}
              name={field?.name}
              value={field?.value}
              onChange={(e) => field.onChange(e.value)}
              optionLabel="label"
              optionValue="value"
            />
          )}
        />
        {showFormErrorMessage(formValidationOptions?.paymentMethod?.name, errors)}
      </div>
    </div>
  );
};

export default TemporaryFundPaymentMethodV2;
